export default __webpack_public_path__ + "assets/models/213b6da98cbc0c13c64a1f706c3edc2a.glb";